<template>
    <div>
        <News-List :data='News'/>
        <Pagination 
        :pageNo="naml.page" 
        :pageSize='naml.limit' 
        :total="News.total" 
        :continues="5"
        @getPageNo='getPageNo'
        />
    </div>
</template>

<script>
import {mapState} from 'vuex'
import NewsList from '@/components/pc/NewsList'
export default {
  data() {
    return {
        naml:{
          class_id:1,
          limit:6,
          page:1,
        },
    }
  },
    components:{
      NewsList
    } ,
    activated() {
        this.postNews(this.naml)
    },
    computed:{
        ...mapState({
            News:state=>state.share.News
        })
    },
    methods: {
        getPageNo(id){
            this.naml.page=id
            this.$store.dispatch('PostNews',this.naml);
        },
        postNews(naml){
            this.$store.dispatch('PostNews',naml);
        }
    },
}
</script>

<style>

</style>